import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Input, DateInput, SelectGeneric, Button } from 'ypf-pas-general-ui-components';

import { checkRol } from '../../../../security';
import {
  aprobador,
  proveedorNotificador,
  proveedorAdministrador
} from '../../../../security/constantsRols';
import useLoadServices from '../../../../hooks/useLoadServices';
import { useFilterContext } from '../../../../context/FilterContext';
import { eventAsignmentEnum, ubicationTypeEnum } from '../../../../utils/dataStatus';

import {
  fetchDataUbication,
  fetchDataContratos,
  fetchDataProveedores,
  fetchDataServicios,
  fetchDataUsuarios,
  fetchDataTeam,
  fetchRequestsService,
  fetchDataUbicationByUbicationType,
  fetchEquipamentTower
} from './helpers/filtersFetcher';

import './ContentFilter.scss';

const checkIsOyM = (tipoUbicacionEnum) =>
  tipoUbicacionEnum?.id !== ubicationTypeEnum.locacion &&
  tipoUbicacionEnum?.id !== ubicationTypeEnum.pozo;

const getSetValue = (isOyM, values) =>
  isOyM ? values?.operacionesIds : values?.unidadesNegocioIds;

const getSetFieldName = (isOyM) => (isOyM ? 'operacionesIds' : 'unidadesNegocioIds');

const ContentFilter = () => {
  const [asignmentType, setAsignmentType] = useState(eventAsignmentEnum.all);
  const { formikFilters, handleChangeFilter, handleClearFilters, handleSaveFilters } =
    useFilterContext();

  const location = useLocation();
  const gridRoute = location.pathname === '/';
  const approverRoute = location.pathname === '/approver';

  const {
    ubicationTypeSelect,
    statusSelect,
    prioritySelect,
    businessUnitSelect,
    eventsSelect,
    eventWithAsignment
  } = useLoadServices({ asignmentType, createSDS: true });

  const { values, handleChange, setFieldValue } = formikFilters;
  // We make a copy since the options will change according to characterization
  const [newEventWithAsignment, setNewEventWithAsignment] = useState([]);

  const isOyM = checkIsOyM(values.tipoUbicacionEnum);
  const setValue = getSetValue(isOyM, values);
  const setFieldName = getSetFieldName(isOyM);

  const handleSetFieldValues = (newValues) =>
    isOyM
      ? setFieldValue('operacionesIds', newValues || [])
      : setFieldValue('unidadesNegocioIds', newValues || []);

  const filterEventsOptions = (typeEventValue) => {
    let filterOptions = eventWithAsignment;

    if (typeEventValue.length) {
      filterOptions = eventWithAsignment.filter(
        (option) => option.caracterizacionId === typeEventValue[0]?.caracterizacionId
      );
    }
    setNewEventWithAsignment([...filterOptions]);
  };

  return (
    <>
      {gridRoute ? (
        <div className="d-flex justify-content-between gap-2">
          <DateInput
            label="Fecha Desde"
            max={values?.fechaHasta}
            name="fechaDesde"
            onChange={handleChange}
            onClear={() => setFieldValue('fechaDesde', '')}
            placeholder="Desde"
            value={values?.fechaDesde}
          />
          <DateInput
            label="Fecha Hasta"
            min={values?.fechaDesde}
            name="fechaHasta"
            onChange={handleChange}
            onClear={() => setFieldValue('fechaHasta', '')}
            placeholder="Hasta"
            value={values?.fechaHasta}
          />
        </div>
      ) : null}
      {(checkRol(proveedorNotificador) || checkRol(proveedorAdministrador)) && gridRoute ? null : (
        <SelectGeneric
          async
          defaultValueOneOption={false}
          fetchData={(value) => fetchDataProveedores(value)}
          isMulti
          label="Proveedores"
          name="idsProveedores"
          noOptionsMessage="Ingresar al menos 3 caracteres"
          onChange={(newValues) => setFieldValue('idsProveedores', newValues || [])}
          paddingIndicator={4}
          placeholder="Buscar por nombre"
          value={values?.idsProveedores}
          withSelect="100%"
        />
      )}
      {gridRoute ? (
        <SelectGeneric
          async
          clearable
          fetchData={(value) => fetchDataContratos(value)}
          isMulti
          label="Contrato"
          name="idsContrato"
          noOptionsMessage="Ingresar al menos 3 caracteres"
          onChange={(newValue) => setFieldValue('idsContratos', newValue)}
          paddingIndicator={4}
          placeholder="Selecciona contrato"
          value={values?.idsContratos}
          withSelect="100%"
        />
      ) : null}
      {gridRoute ? (
        <SelectGeneric
          async
          clearable
          fetchData={(value) => fetchRequestsService(value)}
          isMulti
          label="Solicitud de Servicio"
          name="numeroSolicitud"
          noOptionsMessage="Ingresar al menos 3 caracteres"
          onChange={(newValues) => {
            setFieldValue('numeroSolicitud', newValues);
          }}
          placeholder="Selecciona solicitud de servicio"
          value={values?.numeroSolicitud}
          withSelect="100%"
        />
      ) : (
        <Input
          className="mt-1 mb-4 "
          label="Solicitud"
          name="numeroSolicitud"
          onChange={handleChange}
          onSearchFunction={() => handleChangeFilter(values)}
          placeholder="Buscar por número"
          showIcon
          type="text"
          value={values?.numeroSolicitud}
        />
      )}
      {gridRoute ? (
        <div>
          <div className="event-select-container">
            <input
              checked={values?.asignacionEventoEnum === eventAsignmentEnum.all}
              onChange={() => {
                setAsignmentType(eventAsignmentEnum.all);
                setFieldValue('asignacionEventoEnum', eventAsignmentEnum.all);
              }}
              title="todos"
              type="radio"
            />
            Todo
            <input
              checked={values?.asignacionEventoEnum === eventAsignmentEnum.pending}
              onChange={() => {
                setAsignmentType(eventAsignmentEnum.pending);
                setFieldValue('asignacionEventoEnum', eventAsignmentEnum.pending);
              }}
              title="pendiente"
              type="radio"
            />
            Pendiente
            <input
              checked={values?.asignacionEventoEnum === eventAsignmentEnum.assigned}
              onChange={() => {
                setAsignmentType(eventAsignmentEnum.assigned);
                setFieldValue('asignacionEventoEnum', eventAsignmentEnum.assigned);
              }}
              title="asignado"
              type="radio"
            />
            Asignado
          </div>
          <SelectGeneric
            clearable
            isMulti
            label="Evento"
            name="idEvento"
            onChange={(newValue) => {
              setFieldValue('idEvento', newValue || []);
              filterEventsOptions(newValue);
            }}
            options={newEventWithAsignment.length ? newEventWithAsignment : eventWithAsignment}
            placeholder="Buscá por nombre"
            value={values?.idEvento}
            withSelect="100%"
          />
        </div>
      ) : null}
      <SelectGeneric
        clearable
        isDisabled={!ubicationTypeSelect}
        label="Ubicación del servicio"
        name="tipoUbicacionEnum"
        onChange={(newValues) => {
          setFieldValue('tipoUbicacionEnum', newValues || null);
          setFieldValue('operacionesIds', []);
          setFieldValue('unidadesNegocioIds', []);
        }}
        options={ubicationTypeSelect}
        paddingIndicator={4}
        placeholder="Seleccione tipo de ubicación"
        value={values?.tipoUbicacionEnum}
        withSelect="100%"
      />
      <SelectGeneric
        clearable
        defaultValueOneOption={false}
        isDisabled={!values?.tipoUbicacionEnum}
        isMulti
        label="Unidad de Negocio"
        name={setFieldName}
        onChange={(newValues) => {
          handleSetFieldValues(newValues);
        }}
        options={businessUnitSelect}
        paddingIndicator={4}
        placeholder="Seleccione una opción"
        value={setValue}
        withSelect="100%"
      />
      <SelectGeneric
        async
        clearable
        fetchData={(value) =>
          !gridRoute
            ? fetchDataUbication(value)
            : fetchDataUbicationByUbicationType({
                value,
                typeUbication: values.tipoUbicacionEnum.id
              })
        }
        isDisabled={!values.tipoUbicacionEnum && gridRoute}
        isMulti={!approverRoute}
        label="Ubicación"
        name="ubicacion"
        noOptionsMessage="Ingresar al menos 3 caracteres"
        onChange={(newValues) => {
          setFieldValue('ubicacion', newValues || null);
        }}
        paddingIndicator={4}
        placeholder="Buscar por nombre"
        value={values?.ubicacion && values.ubicacion}
        withSelect="100%"
      />

      {checkRol(aprobador) && approverRoute ? (
        <>
          <SelectGeneric
            clearable
            isDisabled={!eventsSelect}
            label="Tipo de evento"
            name="evento"
            onChange={(newValues) => {
              setFieldValue('evento', newValues || []);
            }}
            options={eventsSelect}
            paddingIndicator={4}
            placeholder="Seleccione tipo de evento"
            value={values?.evento}
            withSelect="100%"
          />
          <SelectGeneric
            async
            fetchData={(value) => fetchDataTeam(value)}
            label="Equipo"
            name="equipo"
            noOptionsMessage="Ingresar al menos 3 caracteres"
            onChange={(newValues) => {
              setFieldValue('equipo', newValues || []);
            }}
            paddingIndicator={4}
            placeholder="Seleccione equipo"
            value={values?.equipo}
            withSelect="100%"
          />
        </>
      ) : null}

      {gridRoute ? (
        <>
          <SelectGeneric
            async
            fetchData={(value) =>
              fetchEquipamentTower({
                value,
                typeUbication: values.tipoUbicacionEnum.id
              })
            }
            isDisabled={!values.tipoUbicacionEnum}
            isMulti
            label="Equipo de torre"
            name="equipo"
            noOptionsMessage="Ingresar al menos 3 caracteres"
            onChange={(newValues) => {
              setFieldValue('equipo', newValues);
            }}
            placeholder="Seleccione equipo"
            value={values?.equipo}
            withSelect="100%"
          />
        </>
      ) : null}
      <SelectGeneric
        async
        defaultValueOneOption={false}
        fetchData={(value) => fetchDataServicios(value)}
        isMulti
        label="Servicio"
        name="idsServicios"
        noOptionsMessage="Ingresar al menos 3 caracteres"
        onChange={(newValues) => setFieldValue('idsServicios', newValues || null)}
        paddingIndicator={4}
        placeholder="Buscar por servicio"
        value={values?.idsServicios}
        withSelect="100%"
      />
      {!gridRoute ? (
        <SelectGeneric
          async
          fetchData={(value) => fetchDataContratos(value)}
          isMulti
          label="Contratos"
          name="idsContrato"
          noOptionsMessage="Ingresar al menos 3 caracteres"
          onChange={(newValue) => setFieldValue('idsContratos', newValue)}
          paddingIndicator={4}
          placeholder="Buscar por número"
          value={values?.idsContratos}
          withSelect="100%"
        />
      ) : null}
      {gridRoute && (
        <>
          <SelectGeneric
            className="select-status"
            clearable
            isDisabled={!statusSelect}
            isMulti
            label="Estado"
            name="estadosEnums"
            onChange={(newValues) => {
              setFieldValue('estadosEnums', newValues || []);
            }}
            options={statusSelect}
            placeholder="Seleccione estado"
            value={values?.estadosEnums}
            withSelect="100%"
          />
          <SelectGeneric
            async
            clearable
            fetchData={(value) => fetchDataUsuarios(value)}
            label="Usuario creador"
            name="idUsuarioCreador"
            noOptionsMessage="Ingresar al menos 3 caracteres"
            onChange={(newValue) => setFieldValue('idUsuarioCreador', newValue)}
            placeholder="Buscar por nombre"
            value={values?.idUsuarioCreador}
            withSelect="100%"
          />
          <SelectGeneric
            clearable
            isDisabled={!statusSelect}
            label="Prioridad"
            name="idPrioridad"
            onChange={(newValues) => setFieldValue('idPrioridad', newValues)}
            options={prioritySelect}
            placeholder="Seleccione prioridad"
            value={values?.idPrioridad}
            withSelect="100%"
          />
        </>
      )}
      <div className="container-buttons">
        <Button
          label="Limpiar"
          onClick={handleClearFilters}
          type="button"
          variant="outline-primary"
        />
        <Button
          label="Guardar"
          onClick={handleSaveFilters}
          type="button"
          variant="outline-primary"
        />
        <Button label="Buscar" type="submit" variant="primary" />
      </div>
    </>
  );
};

export default ContentFilter;
